const brands = [
  { variantCode: '1X51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1P91', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1D31', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1W91', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1E31', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1W31', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1E51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1W11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1P11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '2P11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1N71', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1P51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1N31', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '2P71', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1N11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '2P91', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1E71', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1X31', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1E11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1X11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1D51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1W71', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1D11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1Y51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1N51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1W51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1N91', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '2P31', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '2P51', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1Y91', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1Y71', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1Y31', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1Y11', model: 'BMW 1 Serie 3-deurs (F21)' },
  { variantCode: '1T91', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1R91', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1R11', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1S91', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1B51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1S31', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1B71', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1S11', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1C51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1S71', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1A51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1T11', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1C91', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1T31', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1T51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '2R31', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1A11', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '2R11', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1A31', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1V51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1C11', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1R51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1C31', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1U51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1C71', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1S51', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1B91', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1V71', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1V91', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1V31', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1U71', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1U91', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '1V11', model: 'BMW 1 Serie 5-deurs (F20)' },
  { variantCode: '7K31', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7N51', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7N31', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7K11', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7L51', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7M91', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7K51', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7M71', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '7L11', model: 'BMW 1 Serie 5-deurs (F40)' },
  { variantCode: '21GE', model: 'BMW 1 Serie 5-deurs (F70)' },
  { variantCode: '11GF', model: 'BMW 1 Serie 5-deurs (F70)' },
  { variantCode: '21GF', model: 'BMW 1 Serie 5-deurs (F70)' },
  { variantCode: '81GE', model: 'BMW 1 Serie 5-deurs (F70)' },
  { variantCode: '31GE', model: 'BMW 1 Serie 5-deurs (F70)' },
  { variantCode: '61GE', model: 'BMW 1 Serie 5-deurs (F70)' },
  { variantCode: '6V11', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '6W91', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '6W51', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '6X51', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '6X31', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2E51', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '6V31', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2E71', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2E11', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2D91', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2E31', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2D71', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2D51', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2D31', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '6V51', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '6V71', model: 'BMW 2 Serie Active Gran Tourer (F46)' },
  { variantCode: '2A91', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6U51', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2C31', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2B91', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2A51', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6U11', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2C51', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6U31', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2C11', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6S31', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2A31', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2C71', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2B31', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6Y31', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2A71', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6T51', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6T91', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6S11', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2X91', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '6S71', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2X71', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '2B11', model: 'BMW 2 Serie Active Tourer (F45)' },
  { variantCode: '71BY', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '11BX', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '51BY', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '51BX', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '41BX', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '21EA', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '21BY', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '71BX', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '31BX', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '21BX', model: 'BMW 2 Serie Active Tourer (U06)' },
  { variantCode: '2M31', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2M51', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2N11', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2N31', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2N51', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2N71', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2N91', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '31CL', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2M11', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '1M51', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2L91', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2L51', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '11CL', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '1L71', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '1K51', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '1M11', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2L71', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '1M31', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2K31', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2K51', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2L11', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '2L31', model: 'BMW 2 Serie Cabrio (F23)' },
  { variantCode: '1H71', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2J91', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '1J71', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2F51', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '1J11', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2U11', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '1H31', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2F31', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '1F51', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2F11', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '1J91', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2U31', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2U51', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '1H11', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '11CK', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2G71', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2G51', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2H11', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2H31', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2H51', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2H71', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2J51', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2J71', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2G31', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '11DE', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2G91', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '2G11', model: 'BMW 2 Serie Coupé (F22)' },
  { variantCode: '11CM', model: 'BMW 2 Serie Coupé (G42)' },
  { variantCode: '11CN', model: 'BMW 2 Serie Coupé (G42)' },
  { variantCode: '51CM', model: 'BMW 2 Serie Coupé (G42)' },
  { variantCode: '21CM', model: 'BMW 2 Serie Coupé (G42)' },
  { variantCode: '61CM', model: 'BMW 2 Serie Coupé (G42)' },
  { variantCode: '41CM', model: 'BMW 2 Serie Coupé (G42)' },
  { variantCode: '31GH', model: 'BMW 2 Serie Gran Coupé (F74)' },
  { variantCode: '71GG', model: 'BMW 2 Serie Gran Coupé (F74)' },
  { variantCode: '31GG', model: 'BMW 2 Serie Gran Coupé (F74)' },
  { variantCode: '31AM', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '71AM', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '11AL', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '11AM', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '31AK', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '51AM', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '51AL', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '11AK', model: 'BMW 2 Serie Gran Coupé (F44)' },
  { variantCode: '3Z91', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8T91', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3Y91', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8U11', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3Y71', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8X31', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3X11', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8X51', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3X31', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8Y51', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3X71', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8Y71', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3Y11', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8Y91', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3Y31', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8X71', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3Z71', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8X91', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3Y51', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8X11', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3X91', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8T11', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3X51', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8Y11', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3Z51', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8Y31', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8Z11', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8T31', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8T51', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '8T71', model: 'BMW 3 Serie Gran Turismo (F34)' },
  { variantCode: '3F91', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8E31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3E31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8F11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3A51', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8F31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3A11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3W31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3A91', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8D11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3D71', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8F91', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3D31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8E11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3E11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8B31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3J31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8F71', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3J71', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8B71', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3B11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8F51', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3D11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8C11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3D91', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8B11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3B51', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8A71', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3B91', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8C31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3C31', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8A51', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3D51', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8A11', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3E51', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8C51', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '3J91', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '8C91', model: 'BMW 3 Serie Sedan (F30)' },
  { variantCode: '48GK', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5Y91', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '58GK', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5P91', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5P51', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '51DY', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '28FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '31DY', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '71DY', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5W71', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '11DY', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5U91', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5X71', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5W11', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5R71', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5P31', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '48FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '58FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '68FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5F31', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '78FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '88FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '18FS', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '28FS', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '38FS', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '18FU', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '28FU', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5V91', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5V31', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5F71', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5V51', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5V71', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5R11', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '38FU', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '48FU', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '58FU', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '68FU', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '58CD', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5Y11', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5X91', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '68FT', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '3K31', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8G31', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3K71', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8J11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3H11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8L71', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3H51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8L11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3H91', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8K91', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8J31', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8K71', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3K51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8K51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3L31', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8K11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3G11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8J91', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3L11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3K91', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8H91', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3K11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8H71', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3G71', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8H51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3G91', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8H31', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3L51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8H11', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8J71', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8G91', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '3G51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8G71', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8G51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '8L51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '51GL', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '41FY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '41GL', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '51FY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '61FY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '71FY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '81FY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '71CY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '81CY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '11FZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '21FZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '31FZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '41FZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '51FZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '61FZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '81CE', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '21FY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '31DZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '31ED', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '71DZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6N91', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6N71', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '51DZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '11DZ', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6N31', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6K31', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6N11', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6L91', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6L31', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '11FY', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6M91', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6N51', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6M11', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6M51', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6L71', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6L51', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6K71', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '6K51', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '21GL', model: 'BMW 3 Serie Touring (G21)' },
  { variantCode: '3V11', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4V11', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '3U51', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4V31', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '3U31', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4V51', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '3T71', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4Z51', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '3T31', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4Z71', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '3U11', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '8S11', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '3V31', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '8S31', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '3V51', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '8S51', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4T11', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '8S71', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4U51', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4T51', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4T31', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4U11', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4T91', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4T71', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '4U31', model: 'BMW 4 Serie Cabrio (F33)' },
  { variantCode: '51AU', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '51AT', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '81DB', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '41AT', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '61AU', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '61AT', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '61FP', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '21AT', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '41FP', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '21AU', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '71AU', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '11AT', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '11AU', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '31AU', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '3S31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4P71', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3P51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4X31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3S91', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4X51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3S51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4P91', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3P31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4X71', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3N11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4X91', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3P71', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4N51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3N51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4W91', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3N31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4S11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3P11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4W71', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3R51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4P51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '3R11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4W11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4N31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4N91', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4R11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4P31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4P11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4N71', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4Y11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4S31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4Y31', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4S51', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4S71', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4X11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '4N11', model: 'BMW 4 Serie Coupé (F32)' },
  { variantCode: '51HB', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '11HB', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '71HB', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '21AS', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '41FN', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '11AS', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '51FN', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '51AP', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '61FN', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '11AR', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '71FN', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '11AP', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '41AS', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '51AS', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '81AP', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '41AP', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '71AP', model: 'BMW 4 Serie Coupé (G22)' },
  { variantCode: '4D51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4D11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4A11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4E71', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4G11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4E91', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4B11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4F11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4C31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4H31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4C11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4K91', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4B31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4L11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4A31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4L31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4A71', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4K31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4B71', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4K11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4B51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4H11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4A51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4H51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4H71', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4D31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4F31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4D91', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4H91', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4J51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4J71', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4D71', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4K51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4K71', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4E51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4E31', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4E11', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '4L51', model: 'BMW 4 Serie Gran Coupé (F36)' },
  { variantCode: '51FR', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '61AV', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '51AX', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '61FR', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '11AW', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '61HC', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '21AX', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '41HC', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '31AX', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '11HC', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '71AV', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '41FR', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '61AW', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: '11AV', model: 'BMW 4 Serie Gran Coupé (G26)' },
  { variantCode: 'SN01', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SP01', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'XC01', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'XC21', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'XC41', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'XC61', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'XC81', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SP81', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SP21', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SP61', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SP41', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5M41', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5M21', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5M61', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5N21', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5N41', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5N61', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5N81', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5N01', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: '5M01', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SN81', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SN61', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SN41', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SN21', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'SZ01', model: 'BMW 5 Serie GT (F07)' },
  { variantCode: 'FU71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FW71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FU91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XH71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5E51', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5D91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5D51', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5D31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5C91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5B31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5A71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5E31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FR71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FR91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FS11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FS51', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FW11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FW31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FW51', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FW91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XH31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XG31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XG11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XA91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XA71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XA51', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XA31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'XA11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5D71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FV91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FZ91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5E71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FV71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5D11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5C71', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5B91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5C31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5C11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5E11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5B11', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5A51', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: '5A31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'KP91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'KN91', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'FV31', model: 'BMW 5 Serie Sedan (F10)' },
  { variantCode: 'JB91', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JE31', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '51BL', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '51BJ', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '51BH', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '51AH', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '71AG', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '71BJ', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '31BL', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '31AH', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '11CH', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '11BL', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '11BK', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '11BJ', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '11AH', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '11AG', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '31DW', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JF31', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JF11', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JF51', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JK51', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JR31', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JD51', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JR71', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JC71', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JA11', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JA91', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JD71', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '31CH', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JP91', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JR11', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JS11', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JS31', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '31BK', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JS71', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JC91', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JB31', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JC31', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JC51', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JA51', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JA71', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JB51', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: 'JD11', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '11DW', model: 'BMW 5 Serie Sedan (G30)' },
  { variantCode: '81FJ', model: 'BMW 5 Serie Sedan (G60)' },
  { variantCode: '31FL', model: 'BMW 5 Serie Sedan (G60)' },
  { variantCode: '11FJ', model: 'BMW 5 Serie Sedan (G60)' },
  { variantCode: '21FL', model: 'BMW 5 Serie Sedan (G60)' },
  { variantCode: '11FL', model: 'BMW 5 Serie Sedan (G60)' },
  { variantCode: '71FJ', model: 'BMW 5 Serie Sedan (G60)' },
  { variantCode: '11FK', model: 'BMW 5 Serie Sedan (G60)' },
  { variantCode: '5K41', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5L11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5L51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XB71', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XB51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XB31', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XB11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MU71', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MT11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5G51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XL51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XL31', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MW51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MU91', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'HR91', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5K91', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5K71', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5K51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5K31', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5K11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5J91', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MW91', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5J71', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5J51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5J31', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XL11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5G11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5J11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5L31', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5H31', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5H11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: '5G71', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MY51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MX71', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MX31', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MX51', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MX11', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'XB91', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MZ71', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'MY91', model: 'BMW 5 Serie Touring (F11)' },
  { variantCode: 'JN11', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '51AJ', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JN71', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JL31', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JN31', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '31DX', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JM11', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JN91', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JT71', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '71BM', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '71CG', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JP11', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JP31', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JP51', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JM71', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JN51', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '31BN', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '31BM', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JL11', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '31AJ', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JT11', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JL41', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '11DX', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JT31', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '31CG', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JT51', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JT91', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '51BN', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '11CG', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '11BN', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '11BM', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '51BM', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JL51', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: 'JM91', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '11AJ', model: 'BMW 5 Serie Touring (G31)' },
  { variantCode: '11GW', model: 'BMW 5 Serie Touring (G61)' },
  { variantCode: '21GW', model: 'BMW 5 Serie Touring (G61)' },
  { variantCode: '31GW', model: 'BMW 5 Serie Touring (G61)' },
  { variantCode: '21GV', model: 'BMW 5 Serie Touring (G61)' },
  { variantCode: '31GV', model: 'BMW 5 Serie Touring (G61)' },
  { variantCode: '11GV', model: 'BMW 5 Serie Touring (G61)' },
  { variantCode: '41GV', model: 'BMW 5 Serie Touring (G61)' },
  { variantCode: 'LZ91', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'LW71', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6G91', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'LZ31', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6G31', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'LZ51', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6G11', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'LZ71', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6F71', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6F51', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'YP31', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6F31', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'YP11', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6F11', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'YP91', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: 'YP51', model: 'BMW 6 Serie Cabrio (F12)' },
  { variantCode: '6H71', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'LY11', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: '6J91', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'LW31', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: '6J11', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'LX31', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: '6J31', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'LX51', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: '6H11', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'LX71', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: '6H31', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'YM11', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: '6H51', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'YM91', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'LX91', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: 'YM31', model: 'BMW 6 Serie Coupé (F13)' },
  { variantCode: '6B21', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6A61', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6D01', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6B41', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6D21', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6C91', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6D41', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6A81', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6D61', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6B81', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6A01', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '61BP', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: '41BP', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: '21BP', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JY81', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JY61', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JY41', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JY21', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JY01', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JV21', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JV41', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JV61', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JW61', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JW81', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JW01', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JX81', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JX01', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JX21', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JX61', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: 'JX41', model: 'BMW 6 Serie Gran Turismo (G32)' },
  { variantCode: '7D61', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7R81', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7S21', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7D21', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7S81', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7C81', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7D01', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7C41', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7C21', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7B01', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7A21', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7S41', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7S61', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7R21', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7A81', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7C61', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7A61', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7B81', model: 'BMW 7 Serie Sedan (G11)' },
  { variantCode: '7H01', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7E41', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7J21', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7J01', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7W21', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7J41', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7V81', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7V61', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7V41', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7V21', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7U61', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7U21', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7H61', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7U81', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7E21', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7W41', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7H81', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7F21', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7G41', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7G61', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7T21', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7T41', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7F01', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '7G81', model: 'BMW 7 Serie Sedan lang (G12)' },
  { variantCode: '11EJ', model: 'BMW 7 Serie Sedan (G70)' },
  { variantCode: '21EJ', model: 'BMW 7 Serie Sedan (G70)' },
  { variantCode: '51EH', model: 'BMW 7 Serie Sedan (G70)' },
  { variantCode: '41EH', model: 'BMW 7 Serie Sedan (G70)' },
  { variantCode: 'FY21', model: 'BMW 8 Serie Cabrio Cabrio (G14)' },
  { variantCode: 'FY61', model: 'BMW 8 Serie Cabrio Cabrio (G14)' },
  { variantCode: 'DZ21', model: 'BMW 8 Serie Cabrio Cabrio (G14)' },
  { variantCode: 'FY41', model: 'BMW 8 Serie Cabrio Cabrio (G14)' },
  { variantCode: 'DZ41', model: 'BMW 8 Serie Cabrio Cabrio (G14)' },
  { variantCode: 'AE21', model: 'BMW 8 Serie Coupe (G15)' },
  { variantCode: 'AE41', model: 'BMW 8 Serie Coupe (G15)' },
  { variantCode: 'BC61', model: 'BMW 8 Serie Coupe (G15)' },
  { variantCode: 'BC21', model: 'BMW 8 Serie Coupe (G15)' },
  { variantCode: 'BC41', model: 'BMW 8 Serie Coupe (G15)' },
  { variantCode: 'GV81', model: 'BMW 8 Serie Gran Coupé (G16)' },
  { variantCode: 'GV41', model: 'BMW 8 Serie Gran Coupé (G16)' },
  { variantCode: 'GW41', model: 'BMW 8 Serie Gran Coupé (G16)' },
  { variantCode: 'GV21', model: 'BMW 8 Serie Gran Coupé (G16)' },
  { variantCode: 'GW01', model: 'BMW 8 Serie Gran Coupé (G16)' },
  { variantCode: '1Z21', model: 'BMW i3 (I01) BEV' },
  { variantCode: '7Z21', model: 'BMW i3 (I01) BEV' },
  { variantCode: '1Z41', model: 'BMW i3 (I01) BEV' },
  { variantCode: '7Z41', model: 'BMW i3 (I01) BEV' },
  { variantCode: '7Z61', model: 'BMW i3 (I01) BEV' },
  { variantCode: '7Z81', model: 'BMW i3 (I01) BEV' },
  { variantCode: '1Z61', model: 'BMW i3 (I01) BEV' },
  { variantCode: '1Z81', model: 'BMW i3 (I01) BEV' },
  { variantCode: '8P61', model: 'BMW i3 (I01) BEV' },
  { variantCode: '8P21', model: 'BMW i3 (I01) BEV' },
  { variantCode: '31AW', model: 'BMW i4 (G26) BEV' },
  { variantCode: '21HD', model: 'BMW i4 (G26) BEV' },
  { variantCode: '11HD', model: 'BMW i4 (G26) BEV' },
  { variantCode: '41AW', model: 'BMW i4 (G26) BEV' },
  { variantCode: '31HD', model: 'BMW i4 (G26) BEV' },
  { variantCode: '41HD', model: 'BMW i4 (G26) BEV' },
  { variantCode: '71AW', model: 'BMW i4 (G26) BEV' },
  { variantCode: '51HD', model: 'BMW i4 (G26) BEV' },
  { variantCode: '61HD', model: 'BMW i4 (G26) BEV' },
  { variantCode: '71HD', model: 'BMW i4 (G26) BEV' },
  { variantCode: '41FK', model: 'BMW i5 Sedan (G60) BEV' },
  { variantCode: '61HG', model: 'BMW i5 Sedan (G60) BEV' },
  { variantCode: '41HG', model: 'BMW i5 Sedan (G60) BEV' },
  { variantCode: '31HG', model: 'BMW i5 Sedan (G60) BEV' },
  { variantCode: '31FK', model: 'BMW i5 Sedan (G60) BEV' },
  { variantCode: '11HG', model: 'BMW i5 Sedan (G60) BEV' },
  { variantCode: '31HH', model: 'BMW i5 Touring (G61) BEV' },
  { variantCode: '11HH', model: 'BMW i5 Touring (G61) BEV' },
  { variantCode: '71HH', model: 'BMW i5 Touring (G61) BEV' },
  { variantCode: '61HH', model: 'BMW i5 Touring (G61) BEV' },
  { variantCode: '51HH', model: 'BMW i5 Touring (G61) BEV' },
  { variantCode: '81EH', model: 'BMW i7 (G70) BEV' },
  { variantCode: '41EJ', model: 'BMW i7 (G70) BEV' },
  { variantCode: '51EJ', model: 'BMW i7 (G70) BEV' },
  { variantCode: '2Z21', model: 'BMW i8 (I12) Coupé' },
  { variantCode: '2Z41', model: 'BMW i8 (I12) Coupé' },
  { variantCode: '2Z61', model: 'BMW i8 (I15) Roadster' },
  { variantCode: '21CF', model: 'BMW IX (I20) BEV' },
  { variantCode: '11CF', model: 'BMW IX (I20) BEV' },
  { variantCode: '31CF', model: 'BMW IX (I20) BEV' },
  { variantCode: '61CF', model: 'BMW IX (I20) BEV' },
  { variantCode: '41CF', model: 'BMW IX (I20) BEV' },
  { variantCode: '51CF', model: 'BMW IX (I20) BEV' },
  { variantCode: '61EF', model: 'BMW iX1 (U11) BEV' },
  { variantCode: '71EG', model: 'BMW iX1 (U11) BEV' },
  { variantCode: '51GM', model: 'BMW iX2 (U10) BEV' },
  { variantCode: '71GM', model: 'BMW iX2 (U10) BEV' },
  { variantCode: '7X41', model: 'BMW iX3 (G08) BEV' },
  { variantCode: '41DU', model: 'BMW iX3 (G08) BEV' },
  { variantCode: '31HR', model: 'BMW iX3 (NA5) BEV' },
  { variantCode: '11DM', model: 'BMW M2 (G87) Coupé' },
  { variantCode: '21DM', model: 'BMW M2 (G87) Coupé' },
  { variantCode: '31DM', model: 'BMW M2 (G87) Coupé' },
  { variantCode: '1J31', model: 'BMW M2 Coupé (F87)' },
  { variantCode: '1J51', model: 'BMW M2 Coupé (F87)' },
  { variantCode: '1H91', model: 'BMW M2 Coupé (F87)' },
  { variantCode: '2U71', model: 'BMW M2 Coupé (F87)' },
  { variantCode: '3C91', model: 'BMW M3 Sedan (F80)' },
  { variantCode: '8M91', model: 'BMW M3 Sedan (F80)' },
  { variantCode: '11HJ', model: 'BMW M3 Sedan (G80)' },
  { variantCode: '31AY', model: 'BMW M3 Sedan (G80)' },
  { variantCode: '31HJ', model: 'BMW M3 Sedan (G80)' },
  { variantCode: '61AY', model: 'BMW M3 Sedan (G80)' },
  { variantCode: '21HJ', model: 'BMW M3 Sedan (G80)' },
  { variantCode: '51AY', model: 'BMW M3 Sedan (G80)' },
  { variantCode: '41AY', model: 'BMW M3 Sedan (G80)' },
  { variantCode: '21GB', model: 'BMW M3 Touring (G81)' },
  { variantCode: '11GB', model: 'BMW M3 Touring (G81)' },
  { variantCode: '31BA', model: 'BMW M4 Cabrio (G83)' },
  { variantCode: '41BA', model: 'BMW M4 Cabrio (G83)' },
  { variantCode: '3U91', model: 'BMW M4 Coupé (F82)' },
  { variantCode: '4Z91', model: 'BMW M4 Coupé (F82)' },
  { variantCode: '3R91', model: 'BMW M4 Coupé (F82)' },
  { variantCode: '3S71', model: 'BMW M4 Coupé (F82)' },
  { variantCode: '4Y91', model: 'BMW M4 Coupé (F82)' },
  { variantCode: '4S91', model: 'BMW M4 Coupé (F82)' },
  { variantCode: '41AZ', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '11HK', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '81AZ', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '21HK', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '31AZ', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '31HK', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '51AZ', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '41HK', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '61AZ', model: 'BMW M4 Coupé (G82)' },
  { variantCode: '71CH', model: 'BMW M5 Sedan (F90)' },
  { variantCode: 'JF01', model: 'BMW M5 Sedan (F90)' },
  { variantCode: '81CH', model: 'BMW M5 Sedan (F90)' },
  { variantCode: '81FK', model: 'BMW M5 Sedan (G90)' },
  { variantCode: '81GV', model: 'BMW M5 Touring (G99)' },
  { variantCode: 'JH51', model: 'BMW X1 (F48)' },
  { variantCode: '71AB', model: 'BMW X1 (F48)' },
  { variantCode: 'JJ31', model: 'BMW X1 (F48)' },
  { variantCode: 'HT71', model: 'BMW X1 (F48)' },
  { variantCode: 'JH11', model: 'BMW X1 (F48)' },
  { variantCode: 'HS71', model: 'BMW X1 (F48)' },
  { variantCode: '51AB', model: 'BMW X1 (F48)' },
  { variantCode: 'JG51', model: 'BMW X1 (F48)' },
  { variantCode: 'HT11', model: 'BMW X1 (F48)' },
  { variantCode: 'JG11', model: 'BMW X1 (F48)' },
  { variantCode: 'JG31', model: 'BMW X1 (F48)' },
  { variantCode: '31AE', model: 'BMW X1 (F48)' },
  { variantCode: '31AD', model: 'BMW X1 (F48)' },
  { variantCode: '31AC', model: 'BMW X1 (F48)' },
  { variantCode: '31AA', model: 'BMW X1 (F48)' },
  { variantCode: 'HU11', model: 'BMW X1 (F48)' },
  { variantCode: 'HT91', model: 'BMW X1 (F48)' },
  { variantCode: '71AA', model: 'BMW X1 (F48)' },
  { variantCode: '71AC', model: 'BMW X1 (F48)' },
  { variantCode: '71AD', model: 'BMW X1 (F48)' },
  { variantCode: '11AB', model: 'BMW X1 (F48)' },
  { variantCode: 'JG91', model: 'BMW X1 (F48)' },
  { variantCode: 'JH91', model: 'BMW X1 (F48)' },
  { variantCode: 'HT51', model: 'BMW X1 (F48)' },
  { variantCode: 'JH71', model: 'BMW X1 (F48)' },
  { variantCode: 'HS91', model: 'BMW X1 (F48)' },
  { variantCode: 'JJ11', model: 'BMW X1 (F48)' },
  { variantCode: 'HS11', model: 'BMW X1 (F48)' },
  { variantCode: 'HU51', model: 'BMW X1 (F48)' },
  { variantCode: 'HU31', model: 'BMW X1 (F48)' },
  { variantCode: '21EF', model: 'BMW X1 (U11)' },
  { variantCode: '31EG', model: 'BMW X1 (U11)' },
  { variantCode: '31EF', model: 'BMW X1 (U11)' },
  { variantCode: '51EG', model: 'BMW X1 (U11)' },
  { variantCode: '11EG', model: 'BMW X1 (U11)' },
  { variantCode: '61EE', model: 'BMW X1 (U11)' },
  { variantCode: '11EE', model: 'BMW X1 (U11)' },
  { variantCode: '31EE', model: 'BMW X1 (U11)' },
  { variantCode: '41EG', model: 'BMW X1 (U11)' },
  { variantCode: '11EF', model: 'BMW X1 (U11)' },
  { variantCode: 'YK91', model: 'BMW X2 (F39)' },
  { variantCode: 'YK11', model: 'BMW X2 (F39)' },
  { variantCode: 'YN91', model: 'BMW X2 (F39)' },
  { variantCode: 'YN11', model: 'BMW X2 (F39)' },
  { variantCode: 'YH51', model: 'BMW X2 (F39)' },
  { variantCode: 'YH11', model: 'BMW X2 (F39)' },
  { variantCode: 'YK71', model: 'BMW X2 (F39)' },
  { variantCode: 'YK51', model: 'BMW X2 (F39)' },
  { variantCode: 'YN51', model: 'BMW X2 (F39)' },
  { variantCode: 'YL11', model: 'BMW X2 (F39)' },
  { variantCode: 'YL31', model: 'BMW X2 (F39)' },
  { variantCode: 'YH31', model: 'BMW X2 (F39)' },
  { variantCode: '31GN', model: 'BMW X2 (U10)' },
  { variantCode: '21GM', model: 'BMW X2 (U10)' },
  { variantCode: '81GM', model: 'BMW X2 (U10)' },
  { variantCode: 'WY11', model: 'BMW X3 (F25)' },
  { variantCode: 'WX91', model: 'BMW X3 (F25)' },
  { variantCode: 'WX51', model: 'BMW X3 (F25)' },
  { variantCode: 'WX71', model: 'BMW X3 (F25)' },
  { variantCode: 'WY31', model: 'BMW X3 (F25)' },
  { variantCode: 'WY91', model: 'BMW X3 (F25)' },
  { variantCode: 'WZ31', model: 'BMW X3 (F25)' },
  { variantCode: 'WZ51', model: 'BMW X3 (F25)' },
  { variantCode: 'WY51', model: 'BMW X3 (F25)' },
  { variantCode: 'WX31', model: 'BMW X3 (F25)' },
  { variantCode: 'WY71', model: 'BMW X3 (F25)' },
  { variantCode: 'TS31', model: 'BMW X3 (G01)' },
  { variantCode: 'TX31', model: 'BMW X3 (G01)' },
  { variantCode: 'TX71', model: 'BMW X3 (G01)' },
  { variantCode: 'TR51', model: 'BMW X3 (G01)' },
  { variantCode: 'TR91', model: 'BMW X3 (G01)' },
  { variantCode: 'TX51', model: 'BMW X3 (G01)' },
  { variantCode: 'TX11', model: 'BMW X3 (G01)' },
  { variantCode: 'TR95', model: 'BMW X3 (G01)' },
  { variantCode: 'TX35', model: 'BMW X3 (G01)' },
  { variantCode: 'TX75', model: 'BMW X3 (G01)' },
  { variantCode: 'TX91', model: 'BMW X3 (G01)' },
  { variantCode: 'TR55', model: 'BMW X3 (G01)' },
  { variantCode: 'TX55', model: 'BMW X3 (G01)' },
  { variantCode: 'TX95', model: 'BMW X3 (G01)' },
  { variantCode: 'TX15', model: 'BMW X3 (G01)' },
  { variantCode: 'TY11', model: 'BMW X3 (G01)' },
  { variantCode: 'TY15', model: 'BMW X3 (G01)' },
  { variantCode: 'TY51', model: 'BMW X3 (G01)' },
  { variantCode: 'TY55', model: 'BMW X3 (G01)' },
  { variantCode: 'TY91', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ11', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ15', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ31', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ35', model: 'BMW X3 (G01)' },
  { variantCode: 'TR38', model: 'BMW X3 (G01)' },
  { variantCode: 'TS11', model: 'BMW X3 (G01)' },
  { variantCode: 'TY95', model: 'BMW X3 (G01)' },
  { variantCode: '35BG', model: 'BMW X3 (G01)' },
  { variantCode: '31BG', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ95', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ75', model: 'BMW X3 (G01)' },
  { variantCode: '21DP', model: 'BMW X3 (G01)' },
  { variantCode: '25DP', model: 'BMW X3 (G01)' },
  { variantCode: '51DP', model: 'BMW X3 (G01)' },
  { variantCode: '55DP', model: 'BMW X3 (G01)' },
  { variantCode: '61DP', model: 'BMW X3 (G01)' },
  { variantCode: '81DP', model: 'BMW X3 (G01)' },
  { variantCode: '85DP', model: 'BMW X3 (G01)' },
  { variantCode: '11BZ', model: 'BMW X3 (G01)' },
  { variantCode: '15BZ', model: 'BMW X3 (G01)' },
  { variantCode: '51BZ', model: 'BMW X3 (G01)' },
  { variantCode: '55BZ', model: 'BMW X3 (G01)' },
  { variantCode: '81BZ', model: 'BMW X3 (G01)' },
  { variantCode: '85BZ', model: 'BMW X3 (G01)' },
  { variantCode: '21DN', model: 'BMW X3 (G01)' },
  { variantCode: '25DN', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ71', model: 'BMW X3 (G01)' },
  { variantCode: 'UZ91', model: 'BMW X3 (G01)' },
  { variantCode: '38DN', model: 'BMW X3 (G01)' },
  { variantCode: '65GP', model: 'BMW X3 (G45)' },
  { variantCode: '11GR', model: 'BMW X3 (G45)' },
  { variantCode: '31GP', model: 'BMW X3 (G45)' },
  { variantCode: '71GP', model: 'BMW X3 (G45)' },
  { variantCode: '35GP', model: 'BMW X3 (G45)' },
  { variantCode: '25GR', model: 'BMW X3 (G45)' },
  { variantCode: '11EC', model: 'BMW X3 M (F97)' },
  { variantCode: 'TS01', model: 'BMW X3 M (F97)' },
  { variantCode: 'XW31', model: 'BMW X4 (F26)' },
  { variantCode: 'XX49', model: 'BMW X4 (F26)' },
  { variantCode: 'XX51', model: 'BMW X4 (F26)' },
  { variantCode: 'XW71', model: 'BMW X4 (F26)' },
  { variantCode: 'XX31', model: 'BMW X4 (F26)' },
  { variantCode: 'XX11', model: 'BMW X4 (F26)' },
  { variantCode: 'XW51', model: 'BMW X4 (F26)' },
  { variantCode: 'XW11', model: 'BMW X4 (F26)' },
  { variantCode: '31CA', model: 'BMW X4 (G02)' },
  { variantCode: '61CA', model: 'BMW X4 (G02)' },
  { variantCode: '11DT', model: 'BMW X4 (G02)' },
  { variantCode: 'UJ51', model: 'BMW X4 (G02)' },
  { variantCode: 'UJ71', model: 'BMW X4 (G02)' },
  { variantCode: 'VJ91', model: 'BMW X4 (G02)' },
  { variantCode: '2V11', model: 'BMW X4 (G02)' },
  { variantCode: '2V51', model: 'BMW X4 (G02)' },
  { variantCode: '81CA', model: 'BMW X4 (G02)' },
  { variantCode: 'VJ71', model: 'BMW X4 (G02)' },
  { variantCode: 'VJ31', model: 'BMW X4 (G02)' },
  { variantCode: 'VJ11', model: 'BMW X4 (G02)' },
  { variantCode: '4M91', model: 'BMW X4 (G02)' },
  { variantCode: 'UJ31', model: 'BMW X4 (G02)' },
  { variantCode: 'UJ11', model: 'BMW X4 (G02)' },
  { variantCode: '4M31', model: 'BMW X4 (G02)' },
  { variantCode: 'VJ51', model: 'BMW X4 (G02)' },
  { variantCode: '41DT', model: 'BMW X4 (G02)' },
  { variantCode: '31DT', model: 'BMW X4 (G02)' },
  { variantCode: '4M51', model: 'BMW X4 (G02)' },
  { variantCode: 'UJ01', model: 'BMW X4 M (F98)' },
  { variantCode: '21EC', model: 'BMW X4 M (F98)' },
  { variantCode: 'LS01', model: 'BMW X5 (F15)' },
  { variantCode: 'KS41', model: 'BMW X5 (F15)' },
  { variantCode: 'KT41', model: 'BMW X5 (F15)' },
  { variantCode: 'KR61', model: 'BMW X5 (F15)' },
  { variantCode: 'KT01', model: 'BMW X5 (F15)' },
  { variantCode: 'KR01', model: 'BMW X5 (F15)' },
  { variantCode: 'KS61', model: 'BMW X5 (F15)' },
  { variantCode: 'KS21', model: 'BMW X5 (F15)' },
  { variantCode: 'KS01', model: 'BMW X5 (F15)' },
  { variantCode: 'KS81', model: 'BMW X5 (F15)' },
  { variantCode: 'CV61', model: 'BMW X5 (G05)' },
  { variantCode: '21EU', model: 'BMW X5 (G05)' },
  { variantCode: 'TH41', model: 'BMW X5 (G05)' },
  { variantCode: '21EV', model: 'BMW X5 (G05)' },
  { variantCode: 'CV41', model: 'BMW X5 (G05)' },
  { variantCode: 'JU81', model: 'BMW X5 (G05)' },
  { variantCode: 'JU41', model: 'BMW X5 (G05)' },
  { variantCode: 'TA61', model: 'BMW X5 (G05)' },
  { variantCode: '41EU', model: 'BMW X5 (G05)' },
  { variantCode: '31EU', model: 'BMW X5 (G05)' },
  { variantCode: '11EV', model: 'BMW X5 (G05)' },
  { variantCode: 'CR61', model: 'BMW X5 (G05)' },
  { variantCode: 'CV01', model: 'BMW X5 (G05)' },
  { variantCode: 'KT61', model: 'BMW X5 M (F85)' },
  { variantCode: 'ZW03', model: 'BMW X5 M (F85)' },
  { variantCode: 'JU01', model: 'BMW X5 M (F95)' },
  { variantCode: '11ET', model: 'BMW X5 M (F95)' },
  { variantCode: 'KU21', model: 'BMW X6 (F16)' },
  { variantCode: 'KV21', model: 'BMW X6 (F16)' },
  { variantCode: 'KV41', model: 'BMW X6 (F16)' },
  { variantCode: 'KV61', model: 'BMW X6 (F16)' },
  { variantCode: 'KU61', model: 'BMW X6 (F16)' },
  { variantCode: '11EY', model: 'BMW X6 (G06)' },
  { variantCode: '21EY', model: 'BMW X6 (G06)' },
  { variantCode: 'GT61', model: 'BMW X6 (G06)' },
  { variantCode: 'GT21', model: 'BMW X6 (G06)' },
  { variantCode: 'CY81', model: 'BMW X6 (G06)' },
  { variantCode: 'CY61', model: 'BMW X6 (G06)' },
  { variantCode: 'TC61', model: 'BMW X6 (G06)' },
  { variantCode: 'GT81', model: 'BMW X6 (G06)' },
  { variantCode: '31EX', model: 'BMW X6 (G06)' },
  { variantCode: '41EX', model: 'BMW X6 (G06)' },
  { variantCode: 'KW81', model: 'BMW X6 M (F86)' },
  { variantCode: 'CY01', model: 'BMW X6 M (F96)' },
  { variantCode: '21ET', model: 'BMW X6 M (F96)' },
  { variantCode: 'CW01', model: 'BMW X7 (G07)' },
  { variantCode: 'CW21', model: 'BMW X7 (G07)' },
  { variantCode: 'CW81', model: 'BMW X7 (G07)' },
  { variantCode: 'TB41', model: 'BMW X7 (G07)' },
  { variantCode: 'CX61', model: 'BMW X7 (G07)' },
  { variantCode: '21EM', model: 'BMW X7 (G07)' },
  { variantCode: '31EM', model: 'BMW X7 (G07)' },
  { variantCode: '21EN', model: 'BMW X7 (G07)' },
  { variantCode: '21CS', model: 'BMW XM (G09)' },
  { variantCode: '31CS', model: 'BMW XM (G09)' },
  { variantCode: '11CS', model: 'BMW XM (G09)' },
  { variantCode: 'HF31', model: 'BMW Z4 (G29) Roadster' },
  { variantCode: 'HF51', model: 'BMW Z4 (G29) Roadster' },
  { variantCode: 'HF11', model: 'BMW Z4 (G29) Roadster' },
  { variantCode: 'XM71', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XM91', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XN91', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XR31', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XN11', model: 'MINI 3-deurs (F56)' },
  { variantCode: '11DH', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XN31', model: 'MINI 3-deurs (F56)' },
  { variantCode: '21DH', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XN71', model: 'MINI 3-deurs (F56)' },
  { variantCode: '31DH', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XM51', model: 'MINI 3-deurs (F56)' },
  { variantCode: '51DH', model: 'MINI 3-deurs (F56)' },
  { variantCode: '71DH', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XR51', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XR11', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XY51', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XY31', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XY11', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XR91', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XP91', model: 'MINI 3-deurs (F56)' },
  { variantCode: 'XX91', model: 'MINI 3-deurs (F56)' },
  { variantCode: '11DJ', model: 'MINI 3-deurs (F56) BEV' },
  { variantCode: 'XP31', model: 'MINI 3-deurs (F56) BEV' },
  { variantCode: '21GD', model: 'MINI 3-deurs (F66)' },
  { variantCode: '11GD', model: 'MINI 3-deurs (F66)' },
  { variantCode: '21GC', model: 'MINI 3-deurs (J01) BEV' },
  { variantCode: '11GC', model: 'MINI 3-deurs (J01) BEV' },
  { variantCode: 'XS11', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XU71', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XT11', model: 'MINI 5-deurs (F55)' },
  { variantCode: '51DK', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XS51', model: 'MINI 5-deurs (F55)' },
  { variantCode: '31DK', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XT31', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XU51', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XT71', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XV51', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XS71', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XV31', model: 'MINI 5-deurs (F55)' },
  { variantCode: '21DK', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XV11', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XU91', model: 'MINI 5-deurs (F55)' },
  { variantCode: 'XT91', model: 'MINI 5-deurs (F55)' },
  { variantCode: '51GD', model: 'MINI 5-deurs (F65)' },
  { variantCode: '41GD', model: 'MINI 5-deurs (F65)' },
  { variantCode: '31GC', model: 'MINI Aceman (J05) BEV' },
  { variantCode: '81GC', model: 'MINI Aceman (J05) BEV' },
  { variantCode: 'WJ51', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WJ31', model: 'MINI Cabrio (F57)' },
  { variantCode: '61DL', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WJ91', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WG31', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WG71', model: 'MINI Cabrio (F57)' },
  { variantCode: '21DL', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WH31', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WH71', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WH51', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WH91', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WG11', model: 'MINI Cabrio (F57)' },
  { variantCode: '11DL', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WJ11', model: 'MINI Cabrio (F57)' },
  { variantCode: 'WH11', model: 'MINI Cabrio (F57)' },
  { variantCode: '41DL', model: 'MINI Cabrio (F57)' },
  { variantCode: '81DL', model: 'MINI Cabrio (F57) BEV' },
  { variantCode: 'ZR71', model: 'MINI Cabrio (R57)' },
  { variantCode: 'ZR31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'ZP91', model: 'MINI Cabrio (R57)' },
  { variantCode: 'ZM31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'ZN31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'ZP31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'MR31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'MS31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'XF31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'MR91', model: 'MINI Cabrio (R57)' },
  { variantCode: 'MS91', model: 'MINI Cabrio (R57)' },
  { variantCode: 'JZ51', model: 'MINI Clubman (F54)' },
  { variantCode: 'LU91', model: 'MINI Clubman (F54)' },
  { variantCode: 'LR51', model: 'MINI Clubman (F54)' },
  { variantCode: 'LR71', model: 'MINI Clubman (F54)' },
  { variantCode: 'XK91', model: 'MINI Clubman (F54)' },
  { variantCode: 'XK71', model: 'MINI Clubman (F54)' },
  { variantCode: 'LU31', model: 'MINI Clubman (F54)' },
  { variantCode: 'LU71', model: 'MINI Clubman (F54)' },
  { variantCode: 'XK51', model: 'MINI Clubman (F54)' },
  { variantCode: 'XK31', model: 'MINI Clubman (F54)' },
  { variantCode: 'JZ11', model: 'MINI Clubman (F54)' },
  { variantCode: 'JZ71', model: 'MINI Clubman (F54)' },
  { variantCode: 'JZ31', model: 'MINI Clubman (F54)' },
  { variantCode: 'LV11', model: 'MINI Clubman (F54)' },
  { variantCode: 'LV31', model: 'MINI Clubman (F54)' },
  { variantCode: 'JZ91', model: 'MINI Clubman (F54)' },
  { variantCode: 'LV71', model: 'MINI Clubman (F54)' },
  { variantCode: 'XJ11', model: 'MINI Clubman (F54)' },
  { variantCode: '71BB', model: 'MINI Clubman (F54)' },
  { variantCode: '51BC', model: 'MINI Clubman (F54)' },
  { variantCode: '31BC', model: 'MINI Clubman (F54)' },
  { variantCode: '31BB', model: 'MINI Clubman (F54)' },
  { variantCode: 'LV91', model: 'MINI Clubman (F54)' },
  { variantCode: 'LN31', model: 'MINI Clubman (F54)' },
  { variantCode: 'LN71', model: 'MINI Clubman (F54)' },
  { variantCode: 'LR91', model: 'MINI Clubman (F54)' },
  { variantCode: 'MM91', model: 'MINI Clubman (R55)' },
  { variantCode: 'ZH71', model: 'MINI Clubman (R55)' },
  { variantCode: 'MN51', model: 'MINI Clubman (R55)' },
  { variantCode: 'ZH11', model: 'MINI Clubman (R55)' },
  { variantCode: 'MM31', model: 'MINI Clubman (R55)' },
  { variantCode: 'MH31', model: 'MINI Clubman (R55)' },
  { variantCode: 'ML31', model: 'MINI Clubman (R55)' },
  { variantCode: 'ZG31', model: 'MINI Clubman (R55)' },
  { variantCode: 'ZF31', model: 'MINI Clubman (R55)' },
  { variantCode: 'ZE31', model: 'MINI Clubman (R55)' },
  { variantCode: 'ZG91', model: 'MINI Clubman (R55)' },
  { variantCode: 'XE51', model: 'MINI Clubman (R55)' },
  { variantCode: 'ZH51', model: 'MINI Clubman (R55)' },
  { variantCode: 'MH91', model: 'MINI Clubman (R55)' },
  { variantCode: 'YU71', model: 'MINI Countryman (F60)' },
  { variantCode: 'YT71', model: 'MINI Countryman (F60)' },
  { variantCode: 'YV71', model: 'MINI Countryman (F60)' },
  { variantCode: '21BS', model: 'MINI Countryman (F60)' },
  { variantCode: 'YU11', model: 'MINI Countryman (F60)' },
  { variantCode: 'YU31', model: 'MINI Countryman (F60)' },
  { variantCode: 'YU51', model: 'MINI Countryman (F60)' },
  { variantCode: 'YS91', model: 'MINI Countryman (F60)' },
  { variantCode: 'YS51', model: 'MINI Countryman (F60)' },
  { variantCode: '21BR', model: 'MINI Countryman (F60)' },
  { variantCode: '81BR', model: 'MINI Countryman (F60)' },
  { variantCode: 'YZ91', model: 'MINI Countryman (F60)' },
  { variantCode: 'YX11', model: 'MINI Countryman (F60)' },
  { variantCode: '51BR', model: 'MINI Countryman (F60)' },
  { variantCode: '41BT', model: 'MINI Countryman (F60)' },
  { variantCode: 'YY31', model: 'MINI Countryman (F60)' },
  { variantCode: 'YW51', model: 'MINI Countryman (F60)' },
  { variantCode: 'YW71', model: 'MINI Countryman (F60)' },
  { variantCode: '11BR', model: 'MINI Countryman (F60)' },
  { variantCode: '31BS', model: 'MINI Countryman (F60)' },
  { variantCode: 'YS31', model: 'MINI Countryman (F60)' },
  { variantCode: 'YT11', model: 'MINI Countryman (F60)' },
  { variantCode: 'YT91', model: 'MINI Countryman (F60)' },
  { variantCode: 'YV91', model: 'MINI Countryman (F60)' },
  { variantCode: 'YZ11', model: 'MINI Countryman (F60)' },
  { variantCode: 'YY71', model: 'MINI Countryman (F60)' },
  { variantCode: 'YY91', model: 'MINI Countryman (F60)' },
  { variantCode: 'YW31', model: 'MINI Countryman (F60)' },
  { variantCode: 'YY51', model: 'MINI Countryman (F60)' },
  { variantCode: 'YW11', model: 'MINI Countryman (F60)' },
  { variantCode: 'ZD71', model: 'MINI Countryman (R60)' },
  { variantCode: 'XD31', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZB31', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZB51', model: 'MINI Countryman (R60)' },
  { variantCode: 'XD51', model: 'MINI Countryman (R60)' },
  { variantCode: 'XD71', model: 'MINI Countryman (R60)' },
  { variantCode: 'XD11', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZA31', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZC31', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZD11', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZD51', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZB71', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZC51', model: 'MINI Countryman (R60)' },
  { variantCode: 'ZD31', model: 'MINI Countryman (R60)' },
  { variantCode: '11GA', model: 'MINI Countryman (U25)' },
  { variantCode: '31GA', model: 'MINI Countryman (U25)' },
  { variantCode: '21GA', model: 'MINI Countryman (U25)' },
  { variantCode: '51GA', model: 'MINI Countryman (U25) BEV' },
  { variantCode: '41GA', model: 'MINI Countryman (U25) BEV' },
  { variantCode: 'UB91', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UK31', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UB71', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UA71', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UB31', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UB11', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UB51', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UK51', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UK11', model: 'BMW 1 Serie 3-deurs (E81)' },
  { variantCode: 'UE51', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UH31', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UE31', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UF11', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UF31', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UE11', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UF51', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UD71', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UD11', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UF91', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UG31', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UH51', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UG51', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UD91', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UD51', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UH11', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UD52', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UD72', model: 'BMW 1 Serie 5-deurs (E87)' },
  { variantCode: 'UC11', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UC31', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UR91', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UC71', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UR31', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UR11', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UC91', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UR51', model: 'BMW 1 Serie Coupé (E82)' },
  { variantCode: 'UM11', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'UM51', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'UL91', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'UN91', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'UN71', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'UM91', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'UM71', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'UP11', model: 'BMW 1 Serie Cabrio (E88)' },
  { variantCode: 'CA71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CS11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BH31', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BK71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BK81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BJ41', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BJ31', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BG11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CA91', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CD71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE31', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE51', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BE11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CS21', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG31', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BH41', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CB51', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BF51', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BF71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG21', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CF11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BG21', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CD11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BE71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BF61', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CB71', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CB61', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CA81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CT31', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG61', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BF81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE41', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG51', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CA01', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CF51', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CF21', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CD21', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE61', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CB81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CG41', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BE21', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CD81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CJ51', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CF91', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CC51', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CE21', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BE81', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CT41', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CF01', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CC11', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BJ72', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CC31', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'AL11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AT51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AY31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AL31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EV11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BS51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AM11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BR31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EN11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AY71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EY31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BS11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WB31', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'BL91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BM31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BN51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AM31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BN11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AX51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AM51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WN31', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'BM51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BS31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WB71', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'WL71', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'EX31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BL31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EV31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AP31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EN31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AV11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BW11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BM11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AX31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BW51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BN31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EN51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BR91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EV51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WK71', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'BD11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AT31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BV71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AW11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BP71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EX51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EY71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BW31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BY71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AU51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EZ51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AW51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WA71', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'AR51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AR11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BW71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BD51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AV51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BD31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AP71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BD91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'ER11', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AV31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AW31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AS71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BX91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AL71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EL71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WN71', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'EX91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EP51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WB51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'AX71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AP91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EP31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EL91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AT91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EU71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BV91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EZ71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AT71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AL91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BL95', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WE31', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'ED91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WD71', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'BL92', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'ER91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WM51', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'BV51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BR92', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EU31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EW51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WC31', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'WD51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'EU51', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WC51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'WD11', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'EP71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BS71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'AN31', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BW52', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'EX71', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BN52', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BW91', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BS52', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'BW32', model: 'BMW 3 Serie (E46)' },
  { variantCode: 'WE51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'PF51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VA51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VA71', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VB11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VF51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PG31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PF31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VB31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PH31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VF91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VF31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PP51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VC31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VE31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PN11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VC11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VF71', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PM11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VC91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VB71', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PN31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VG11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PG11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VC51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VD11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PM71', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PM51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PK31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VG91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VE71', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PP11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PR91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VD31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PN91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VD71', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PP91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PN51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PN71', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VD51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PL11', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PR51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PL31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PL51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PR31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VD91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PM91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'VE51', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'PP31', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'US31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VR71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VR51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VS11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'US91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VR31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'US11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UT71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UY71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VR91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VU31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UX11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UT31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VS31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UX31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UY11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VV31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VS71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VU11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VT11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VU91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UV51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UU51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VL31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VW11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UY91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VU51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UV91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VU71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VT31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UX91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UX51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VS91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VN11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UX71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VT51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UV71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UU71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UU11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VV71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UU91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VM11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UW91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UY51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UW71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VT91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VL91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'UY31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VP31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VV51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VP51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VM31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VV91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VM91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VN31', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VP11', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VL51', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VN71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VP71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VZ91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VP91', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'VM71', model: 'BMW 3 Serie Touring (E91)' },
  { variantCode: 'KD71', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KE51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KG71', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KG91', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KG51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KK31', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KF91', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KD91', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KK91', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KF51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'KK51', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'DV51', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DW51', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DX71', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'WL91', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DX91', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DV71', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DX51', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DY31', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DY71', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'DT41', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DS41', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DT21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DD41', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DM41', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DT61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DE91', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DD61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DD31', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DM61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DS21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DP81', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DD11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DL81', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DR41', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DN61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DN21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DM11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DR61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DD21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DE21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DT11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DH61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DD51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DM21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DE61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DM31', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DT31', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DP61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DF81', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DH41', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DL01', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DS11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DT51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DJ61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DF71', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DG81', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DS31', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DH31', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DM51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DR11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DS51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DP01', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DR31', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DP71', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DR21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DH11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DL91', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DL71', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DH51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DF51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DP91', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DP51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DN81', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DH21', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DN11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DM71', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DG71', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DN51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DR51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DE11', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DE51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DJ51', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'DR71', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'NA31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NA71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NA51', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NT31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NE31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NU31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NE51', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NU71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NE71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'ND71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NB31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NC51', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NC71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NB91', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NC91', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NX31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NX51', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NX71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NC31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NB51', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NR71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NX91', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NV71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NF71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NW51', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NB11', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NW31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NX11', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NF31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NV31', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NY71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NY51', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NM71', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NX32', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'NC32', model: 'BMW 5 Serie Sedan (E60)' },
  { variantCode: 'PT11', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NG51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PU31', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PU71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NL31', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NL51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NK71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NJ51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PX31', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NL71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PX51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NJ91', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PX71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NH31', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NJ71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NS71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NN71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NJ31', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PV71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PX91', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NH51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PX11', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NN51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PV31', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PY71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PW51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NP71', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'PY51', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'NJ92', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'DZ01', model: 'BMW M8 Cabrio (F91)' },
  { variantCode: 'AE01', model: 'BMW M8 Coupé (F92)' },
  { variantCode: 'GV01', model: 'BMW M8 Gran Coupé (F93)' },
  { variantCode: 'PA91', model: 'BMW X3 (E83)' },
  { variantCode: 'PA71', model: 'BMW X3 (E83)' },
  { variantCode: 'PC71', model: 'BMW X3 (E83)' },
  { variantCode: 'PC31', model: 'BMW X3 (E83)' },
  { variantCode: 'PA31', model: 'BMW X3 (E83)' },
  { variantCode: 'PE11', model: 'BMW X3 (E83)' },
  { variantCode: 'PC91', model: 'BMW X3 (E83)' },
  { variantCode: 'PB51', model: 'BMW X3 (E83)' },
  { variantCode: 'PD91', model: 'BMW X3 (E83)' },
  { variantCode: 'PB11', model: 'BMW X3 (E83)' },
  { variantCode: 'PD51', model: 'BMW X3 (E83)' },
  { variantCode: 'PD71', model: 'BMW X3 (E83)' },
  { variantCode: 'PD11', model: 'BMW X3 (E83)' },
  { variantCode: 'PE71', model: 'BMW X3 (E83)' },
  { variantCode: 'PA72', model: 'BMW X3 (E83)' },
  { variantCode: 'BT51', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BT31', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BT11', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BZ11', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BU11', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BU51', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BU31', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BT91', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BT32', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BT52', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'BZ12', model: 'BMW Z4 (E85) Roadster' },
  { variantCode: 'DU51', model: 'BMW Z4 (E86) Coupé' },
  { variantCode: 'DU91', model: 'BMW Z4 (E86) Coupé' },
  { variantCode: 'DU52', model: 'BMW Z4 (E86) Coupé' },
  { variantCode: 'LM31', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: 'LM71', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: 'LL11', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: 'LL31', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: 'LM11', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: 'LM51', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: 'LL51', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: 'LM32', model: 'BMW Z4 (E89) Roadster' },
  { variantCode: '5P58', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '21FS', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '11FS', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5F38', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '31FS', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '41FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '5P98', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '51FF', model: 'BMW 3 Serie Sedan (G20)' },
  { variantCode: '8J51', model: 'BMW 3 Serie Touring (F31)' },
  { variantCode: '71DB', model: 'BMW 4 Serie Cabrio (G23)' },
  { variantCode: '6E41', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '6E91', model: 'BMW 6 Serie Gran Coupé (F06)' },
  { variantCode: '11HM', model: 'BMW iX1 (U11) BEV' },
  { variantCode: '21HM', model: 'BMW iX1 (U11) BEV' },
  { variantCode: '71GN', model: 'BMW iX2 (U10) BEV' },
  { variantCode: '81GN', model: 'BMW iX2 (U10) BEV' },
  { variantCode: '11HR', model: 'BMW iX3 (NA5) BEV' },
  { variantCode: 'XP11', model: 'MINI 3-deurs (F56)' },
  { variantCode: '31GD', model: 'MINI 3-deurs (F66)' },
  { variantCode: '11HF', model: 'MINI 3-deurs (J01) BEV' },
  { variantCode: 'XS91', model: 'MINI 5-deurs (F55)' },
  { variantCode: '21HF', model: 'MINI Aceman (J05) BEV' },
  { variantCode: '11GX', model: 'MINI Cabrio (F57)' },
  { variantCode: '21GX', model: 'MINI Cabrio (F57)' },
  { variantCode: '31GX', model: 'MINI Cabrio (F57)' },
  { variantCode: 'SY11', model: 'MINI Cabrio (R57)' },
  { variantCode: 'SY31', model: 'MINI Cabrio (R57)' },
  { variantCode: 'SY91', model: 'MINI Cabrio (R57)' },
  { variantCode: 'SY51', model: 'MINI Cabrio (R57)' },
  { variantCode: '41BR', model: 'MINI Countryman (F60)' },
  { variantCode: '81GA', model: 'MINI Countryman (U25) BEV' },
  { variantCode: '11HP', model: 'MINI Countryman (U25) BEV' },
  { variantCode: 'BG91', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'BK91', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'CD91', model: 'BMW 3 Serie (E36)' },
  { variantCode: 'WD91', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'WE71', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'WD31', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'WC71', model: 'BMW 3 Serie Coupé (E92)' },
  { variantCode: 'WM31', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'WM71', model: 'BMW 3 Serie Cabrio (E93)' },
  { variantCode: 'VA91', model: 'BMW 3 Serie Sedan (E90)' },
  { variantCode: 'DS61', model: 'BMW 5 Serie (E39)' },
  { variantCode: 'PV91', model: 'BMW 5 Serie Touring (E61)' },
  { variantCode: 'EH71', model: 'BMW 6 Serie Coupé (E63)' },
{ variantCode: 'EH31', model: 'BMW 6 Serie Coupé (E63)' },
{ variantCode: 'EH11', model: 'BMW 6 Serie Coupé (E63)' },
{ variantCode: 'EH91', model: 'BMW 6 Serie Coupé (E63)' },
{ variantCode: 'EA31', model: 'BMW 6 Serie Coupé (E63)' },
{ variantCode: 'EA51', model: 'BMW 6 Serie Coupé (E63)' },
{ variantCode: 'EA71', model: 'BMW 6 Serie Coupé (E63)' },
];



